import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons/faExternalLinkAlt';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PropTypes } from 'prop-types';
import { Button } from 'react-bootstrap';
import { errorToast } from '../../helpers/toasts/ToastUtils';
import { openIrrimaxWindow } from '../helpers';

const IrrimaxSiteButton = ({ site, graphUrl }) => {
  return (
    <Button
      key={site.id}
      className='mx-2 my-2'
      variant='outline-dark'
      onClick={() => {
        if (!graphUrl) {
          errorToast('No graph URL found for this site.');
          return;
        }
        openIrrimaxWindow(graphUrl);
      }}
    >
      <img
        src='https://fruition-metwatch-assets.s3-ap-southeast-2.amazonaws.com/sentek-logo-16.png'
        alt='sentek-logo'
        style={{ paddingBottom: '2px', marginRight: '2px' }}
      />{' '}
      View on IrriMAX Live{' '}
      <FontAwesomeIcon
        className='ml-1'
        icon={faExternalLinkAlt}
        size='sm'
        style={{ marginBottom: '1px', marginLeft: '2px' }}
      />
    </Button>
  );
};

IrrimaxSiteButton.propTypes = {
  site: PropTypes.object.isRequired,
  graphUrl: PropTypes.string
};

export default IrrimaxSiteButton;

